// import vuetify from './plugins/vuetify';
import Vue from 'vue';
import VueRouter from 'vue-router';

import App from './App';
import { routes } from './routes';
import { store} from './store/store'

import { i18n } from "./translations/i18n";

import { getWebContentIdOfMatchedName, createUrlString, getActiveDataType } from "./store/helpers";

AUI().use('liferay-portlet-url')

Vue.use(VueRouter);

const router = new VueRouter({
	//mode: 'history',
	routes,
	strict: true
});

router.beforeEach(async (to, from, next) => {

	// Always close dropdown when url changes
	store.dispatch('setComponentSelectionDropdownOpen', false);

	// New URL request, initialize category data
	if (!from.name) {
		await store.dispatch("initCategoryData")
	}

	// Request is to non-topic page, clear active topic
	if (!to.params.componentName) {
		store.dispatch('setActiveTopic', {})
	}

	if (to.params.categoryName) {

		const targetCategory = store.getters['getCategories'].find((cat) => createUrlString(cat.name) == to.params.categoryName)
		if (!targetCategory) {
			console.error("Category is missing, rerouting to frontpage")
			router.push({
				name: "frontpage"
			});
		}

		// Initialize topic if it is not already initialized
		if (targetCategory && !store.getters["getCategoryTopics"](targetCategory.id)) {
			await store.dispatch("initTopicData", targetCategory.id)
		}

		const targetTopic = store.getters["getCategoryTopics"](targetCategory.id);
		if (!targetTopic) {
			console.error("Topic is missing, rerouting to frontpage")
			router.push({
				name: "frontpage"
			});
		}

		if (to.params.componentName) {
			// Compare response and URL names, and return web content id of matching topic
			const webContentIdOfMatchedName = getWebContentIdOfMatchedName(to, from, targetTopic)
			if (!webContentIdOfMatchedName) {
				console.error("Component is missing, rerouting to frontpage")
				router.push({
					name: "frontpage"
				});
			}

			// Request has component info, e.g. /1970-80-luvun-rakennus/
			// If componentName (e.g. /1970-80-luvun-rakennus/) stays same do not re-initialize componentPage data
			if (from.params.componentName === to.params.componentName) {
				initializeViewData(to.params)
			} else {
				// Note: waits for response before continuing to next step, allowing e.g. getUniqueDataTypes to access existing data
				store.dispatch('initComponentPageData', webContentIdOfMatchedName).then((res) => {
					initializeViewData(to.params);
				});
			}
		}
	}

	if (to.params.scrollToTop) {
		Vue.nextTick(() => {
			window.scrollTo({top: 0});
		})
	}

	if (i18n.locale !== 'fi') {
		if (!to.query.hasOwnProperty('lang') && (from.query.hasOwnProperty('lang'))) {
			return next({name: to.name, query: from.query})
		} else {
			return next()
		}
	} else {
		next()
	}
})

// Helper for initializing component view into state
function initializeViewData(toParams) {

	let streetViewName = i18n.messages[i18n.locale].hellovue.view.street_view;
	let crossSectionViewName = i18n.messages[i18n.locale].hellovue.view.cross_section_view;

	// E.g. /1970-80-luvun-rakennus/poikkileikkausnakyma/
	if (toParams.view) {
		if(toParams.view == streetViewName) {
			store.dispatch('setStreetView', streetViewName);
		} else if (toParams.view == crossSectionViewName) {
			store.dispatch('setStreetView', crossSectionViewName);
		} else {
			console.log("View data not found")
		}

		// Continue into initializing component/sub-component data
		initializeLowerComponentData(toParams.dataType, toParams.subComponent)
	}

}

// Helper for initializing data into state, based on parameters
function initializeLowerComponentData(dataTypeParam, subComponentParam) {

	// 2. Request has type info, e.g. /1970-80-luvun-rakennus/poikkileikkausnakyma/lvi-tekniikka-ja-automaatio/
	if (dataTypeParam) {

		let activeDataType = getActiveDataType(store.getters['getUniqueDataTypes'], dataTypeParam);
		store.dispatch("setActiveDataType", activeDataType);
		
		// 3. Request has subcomponent info, e.g. /1970-80-luvun-rakennus/poikkileikkausnakyma/lvi-tekniikka-ja-automaatio/termostaattinen-patteriventtiili
		if (subComponentParam) {
			initializeSubComponentData(store.getters['getDataByType'](activeDataType), subComponentParam)
		} else {
      store.dispatch('SideNavigationWideClose'); // Close possibly open sideNavigationWide
		}
	} else {
		store.dispatch("setActiveDataType", "");
		store.dispatch('SideNavigationWideClose'); // Close possibly open sideNavigationWide
	}
}

function initializeSubComponentData(activeSidePanelDataArray, subComponentParam) {
						
	let matchedSubComponent = null;
	for(let sidePanelData of activeSidePanelDataArray) {
		const modifiedName = createUrlString(sidePanelData.name.split(":").pop());
		sidePanelData.urlName = modifiedName; // Add url-version of name to item state. TODO: unnecessary, remove?
		
		if (modifiedName === subComponentParam) {
			matchedSubComponent = sidePanelData;
			break;
		}
	}

	if (matchedSubComponent) {
		store.dispatch('SideNavigationWideOpen');
		store.dispatch('activateSidePanelData', matchedSubComponent);
		store.dispatch('setActiveMapButton', matchedSubComponent.id);
	}
}

new Vue({
	i18n,
	router,
	store,
	el: '#_liferayhellovueweb_app',
	render: h => h(App),
	data() {
		return {
			portletId: 'liferayhellovueweb'
		}
	}
});
